<template>
  <v-container fluid>
    <v-layout class="hide-on-print" row wrap>
      <v-flex xs12>
        <v-card>
          <v-tabs
              fixed-tabs
              background-color="primary"
              dark
              height="40"
              v-model="tab">
            <v-tab href="#detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              Trekking Detail
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              Trekking History
            </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item value="detail">
                <v-card class="mb-5">
                  <v-card-text>
                    <v-flex class="d-flex justify-space-between align-center mb-5" xs12>
                      <h3 class="font-weight-bold">Trekking Request
                        <v-chip class="text-white font-weight-thin ml-2" :color="statusColor">
                          {{ latest_status }}
                        </v-chip>
                      </h3>
                    </v-flex>

                    <v-flex>
                      <v-alert outlined type="info" v-if="trekkingData.assignment">
                        <div class="d-flex align-end"
                             v-if="trekkingData.assignment.assignee_id === user.id">
                          <div class="mr-2">Please proceed for
                            {{ trekkingData.assignment.purpose_name }}.
                          </div>
                          <div v-if="trekkingData.assignment.remarks">
                            ({{ trekkingData.assignment.remarks }})
                          </div>
                        </div>
                        <div v-else>
                          This application has been forwarded to
                          {{ trekkingData.assignment.assignee_name }} for
                          {{ trekkingData.assignment.purpose_name }}
                        </div>
                      </v-alert>
                    </v-flex>

                    <v-flex
                        v-if="item.isExpedition === 'true' || item.isExpedition === true"
                        v-for="item in trekkingData.extra"
                    >
                      <v-alert outlined type="info">
                        This trekking request has expedition recommendation letter.
                      </v-alert>
                    </v-flex>

                    <v-flex v-if="item.isExtension === 'true'" v-for="item in trekkingData.extra">
                      <v-alert outlined type="info">
                        This is extension request for trekking permit.
                      </v-alert>
                    </v-flex>

                    <v-layout row wrap class="mx-1">
                      <v-flex sm8>
                        <confirmation-header-text class="pl-2" icon="mdi-alpha-t-box"
                                                  text="Trekking Route"/>
                      </v-flex>
                      <v-flex sm4
                              v-if="trekkingData.trekkingAgency && trekkingData.trekkingAgency.deleted_at === null">
                        <div class="d-flex justify-end">
                          <v-btn
                              :href="'/system/trekking-agencies/'+trekkingData.trekkingAgency.id"
                              :to="'/system/trekking-agencies/'+trekkingData.trekkingAgency.id"
                              color="primary"
                              dark
                              dense
                              small
                              text
                          >
                            View Trekking Agency detail
                          </v-btn>
                        </div>
                      </v-flex>
                      <v-flex sm3 xs12>
                        <list-item-detail :sub_title="trekkingData.trekkingRoute.name"
                                          title="Trekking Route">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.no_of_days" xs12>
                        <list-item-detail :sub_title="trekkingData.no_of_days"
                                          title="Number Of Days">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.starting_date" xs12>
                        <list-item-detail :sub_title="trekkingData.starting_date"
                                          title="Starting Date">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 v-if="trekkingData.end_date" xs12>
                        <list-item-detail :sub_title="trekkingData.end_date" title="End Date">
                        </list-item-detail>
                      </v-flex>
                      <v-flex sm3 xs12>
                        <file-list-item-detail :avatar="true" v-for="item in trekkingData.extra"
                                               v-if="item.iternary_file"
                                               :src="item.iternary_file"
                                               sub_title="Iternary File">
                        </file-list-item-detail>
                      </v-flex>
                      <v-flex sm3 xs12>
                        <file-list-item-detail :avatar="true" v-for="item in trekkingData.extra"
                                               v-if="item.expedition_recommendation_file"
                                               :src="item.expedition_recommendation_file"
                                               sub_title="Expedition Recommendation File">
                        </file-list-item-detail>
                      </v-flex>
                    </v-layout>

                    <v-divider class="my-3"/>

                    <v-layout row wrap class="mx-1">
                      <confirmation-header-text class="pl-2" icon="mdi-account"
                                                text="Trekker's Info:"/>

                      <v-flex class="pt-0" xs12>
                        <v-simple-table class="" light>
                          <thead>
                          <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">DOB</th>
                            <th class="text-left">Country</th>
                            <th class="text-left">Document Type</th>
                            <th class="text-left">Document number</th>
                            <th class="text-left">Validity</th>
                            <th class="text-left">Visa Status</th>
                            <th class="text-left">Is Free?</th>
                            <th class="text-left">Free Recommendation File</th>
                            <th class="text-left">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr :key="item.passport_number"
                              v-for="item in trekkingData.trekkers">
                            <td v-if="item.country !== 'India'">
                              <v-btn :href="'/system/travellers-history/view/'+item.id"
                                     :to="'/system/travellers-history/view/'+item.id"
                                     class="px-0"
                                     text color="primary">{{ item.name }}
                              </v-btn>
                            </td>
                            <td v-else>{{ item.name }}</td>
                            <td>{{ item.dob }}</td>
                            <td>{{ item.country }}</td>
                            <td>{{ item.document_type }}</td>
                            <td>{{ item.passport_number }}</td>
                            <td>{{ item.validity }}</td>
                            <td>{{ item.visa ? 'Approved' : 'Unapproved' }}</td>
                            <td>{{
                                (item.isFree === 'true' || (getAge(item.dob) < 10 && item.country != 'United States of America (USA)')) ? 'Yes' : 'No'
                              }}
                            </td>
                            <td>
                              <file-display
                                  :src="item.free_recommendation_file"></file-display>
                            </td>
                            <td>
                              <v-btn
                                  @click="singlePrintSticker(item.id)"
                                  class="text-white"
                                  color="blue lighten-1 ml-2"
                                  v-if="(trekkingData.paid ||
                                  parseFloat(trekkingData.total_cost) === 0.00) &&
                                  trekkingData.status ==='Approved' &&
                                  trekkingData.print_trekking_sticker &&
                                  $oauth.checkIfHasPermission(['print-trekking-sticker'])">
                                Print Sticker
                              </v-btn>
                            </td>
                          </tr>
                          </tbody>
                        </v-simple-table>
                      </v-flex>
                    </v-layout>

                    <v-divider class="my-3"/>

                    <v-layout row wrap class="mx-1">
                      <confirmation-header-text class="pl-2" icon="mdi-account"
                                                text="Nepali Guide Info:"/>
                      <template v-for="guide in trekkingData.guides">
                        <v-flex :key="'g'+guide.id" sm3 xs12>
                          <list-item-detail :sub_title="guide.name" title="Full Name">
                          </list-item-detail>
                        </v-flex>
                        <v-flex :key="'g1'+guide.id" sm3 xs12>
                          <list-item-detail :sub_title="guide.mobile_number"
                                            title="Mobile Number">
                          </list-item-detail>
                        </v-flex>
                        <v-flex :key="'g2'+guide.id" sm3 xs12>
                          <list-item-detail :sub_title="guide.citizenship_number"
                                            title="Citizenship No">
                          </list-item-detail>
                        </v-flex>
                        <v-flex :key="'g4'+guide.id" sm3 xs12>
                          <file-list-item-detail :avatar="true"
                                                 :src="guide.insurance_file"
                                                 sub_title="Insurance File">
                          </file-list-item-detail>

                        </v-flex>
                      </template>
                    </v-layout>
                    <v-divider class="my-3"/>

                    <v-layout row wrap class="mx-1">
                      <confirmation-header-text
                          v-if="trekkingData && trekkingData.porters &&  trekkingData.porters.length > 0"
                          class="pl-2" icon="mdi-account"
                          text="Staff's Info:"
                      />
                      <template
                          v-if="trekkingData && trekkingData.porters.length > 0"
                          v-for="(porter) in trekkingData.porters"
                      >
                        <v-flex :key="'p1'+porter.id" sm2 xs12>
                          <list-item-detail :sub_title="porter.name" title="Full Name:"/>
                        </v-flex>
                        <v-flex :key="'p2'+porter.id" sm2 xs12>
                          <list-item-detail :sub_title="porter.designation"
                                            title="Designation:"/>
                        </v-flex>
                        <v-flex :key="'p3'+porter.id" sm3 xs12>
                          <list-item-detail :sub_title="porter.mobile_number"
                                            title="Mobile Number:"/>
                        </v-flex>
                        <v-flex :key="'p4'+porter.id" sm3 xs12>
                          <list-item-detail :sub_title="porter.citizenship_number"
                                            title="Citizenship No:"/>
                        </v-flex>
                        <v-flex :key="'p5'+porter.id" sm2 xs12>
                          <file-list-item-detail :avatar="true" :src="porter.insurance_file"
                                                 sub_title="Insurance File"/>
                        </v-flex>
                      </template>
                    </v-layout>

                    <v-divider
                        v-if="trekkingData && trekkingData.porters && trekkingData.porters.length > 0"
                        class="my-3"
                    />

                    <v-layout row wrap class="mx-1">
                      <payment-detail
                          v-if="trekkingData.paid"
                          :payment_detail="trekkingData.payment_detail"
                          :total_cost=trekkingData.total_cost
                          :paid="trekkingData.paid" :type="'trekking'"
                      />
                      <v-flex v-else xs12>
                        <v-flex class="row pl-2" xs12>
                          <v-icon left medium>mdi-alpha-p-box</v-icon>
                          <span class="font-weight-bold"
                                style="color: black; font-size: 15px;">
                                                        Payment Info
                                                        <v-tooltip top v-if="!trekkingData.is_verified">
                                                          <template v-slot:activator="{ on }">
                                                              <v-btn
                                                                  @click="editTrekkingPrice"
                                                                  class="mr-2"
                                                                  color="#FF8316"
                                                                  dark
                                                                  dense
                                                                  fab
                                                                  v-on="on"
                                                                  x-small
                                                              >
                                                          <v-icon small>edit</v-icon>
                                                              </v-btn>
                                                          </template>
                                                          <span>Edit information</span>
                                                      </v-tooltip>
                                                      </span>
                        </v-flex>

                        <v-flex row wrap class="mx-1" xs12>
                          <v-flex v-if="trekkingData.total_cost" xs3>
                            <list-item-detail :sub_title="trekkingData.total_cost"
                                              title="Charge For Trekking Permit(USD)">
                            </list-item-detail>
                          </v-flex>
                          <v-flex v-if="trekkingData.total_cost_npr" xs3>
                            <list-item-detail :sub_title="trekkingData.total_cost_npr"
                                              title="Charge For Trekking Permit(NPR)">
                            </list-item-detail>
                          </v-flex>
                          <v-flex v-if="trekkingData.voucher_number" xs3>
                            <list-item-detail :sub_title="trekkingData.voucher_number"
                                              title="Voucher Number">
                            </list-item-detail>
                          </v-flex>
                        </v-flex>
                      </v-flex>

                      <v-flex xs12>
                        <v-dialog
                            class="hide-on-print"
                            persistent
                            v-model="tippaniDialog"
                            width="800"
                        >
                          <v-card class="hide-on-print">
                            <v-toolbar color="blue darken-3" dark v-if="step===1">
                              <v-toolbar-title>Generate tippani</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text class="pa-0">
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex :class="{'hide':step ===2}" xs12>
                                    <v-form class="pa-2" lazy-validation
                                            ref="formRef">
                                      <v-layout row wrap>
                                        <v-flex class="py-0" xs12>
                                          <v-select
                                              :items="tippanis"
                                              @change="fillTippani"
                                              item-text="name"
                                              item-value="id"
                                              label="Tippani type"
                                              outlined
                                              v-model="selectedTippani"
                                          />
                                        </v-flex>
                                        <v-flex class="py-0" xs12>
                                          <div>
                                            <div id="editor"></div>
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                    </v-form>
                                  </v-flex>
                                  <v-flex :class="{'hide':step ===1}">
                                    <trekking-request-tippani-print-content/>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-divider style="margin-top:31px;"/>
                            <v-card-actions>
                              <v-spacer/>
                              <v-btn @click="cancel" class="white--text"
                                     color="red lighten-1">
                                Cancel
                              </v-btn>
                              <v-btn
                                  @click="proceed"
                                  class="white--text"
                                  color="blue darken-3 "
                                  v-if="step===1"
                              >
                                Proceed
                              </v-btn>
                              <v-btn
                                  @click="print('tippani')"
                                  class="white--text"
                                  color="blue darken-3"
                                  v-if="step === 2"
                              >Print
                              </v-btn>
                              <v-btn
                                  @click="save"
                                  class="white--text"
                                  color="blue darken-3"
                                  v-if="step === 2 && (trekkingData.voucher_generated || trekkingData.total_cost == 0)"
                              >Save
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>

                <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                  <v-layout row wrap
                            v-if="!trekkingData.is_verified && !trekkingData.approve_rejected">
                    <v-spacer/>
                    <v-btn @click="verifyTrekking" :loading="loading" class="text-white"
                           color="blue mr-2"
                           v-if="trekkingData.can_verify">
                      Verify
                    </v-btn>
                    <v-btn
                        @click="rejectModal=true "
                        class="text-white ml-2"
                        color="red lighten-1"
                        v-if=" trekkingData.can_verify">
                      Reject
                    </v-btn>
                  </v-layout>
                  <v-layout row wrap v-else>
                    <v-spacer/>
                    <v-btn v-if="showForward" @click="forwardToUser(1)"
                           class="text-white" color="blue mr-2">
                      Forward
                    </v-btn>
                    <v-btn @click="verifyTippaniGenerated" class="text-white" color="blue mr-2"
                           v-if="showTippaniVerification">
                      Verify Tippani
                    </v-btn>
                    <v-btn @click="approveTippaniGenerated" class="text-white" color="blue mr-2"
                           v-if="showTippaniApprove">
                      Approve Tippani
                    </v-btn>
                    <v-btn @click="generateTippani" class="text-white" color="blue mr-2"
                           v-if="(trekkingData.voucher_generated || trekkingData.total_cost == 0) && !trekkingData.tippani_generated">
                      Generate tippani
                    </v-btn>
                    <v-btn @click="print('tippani')" v-if="trekkingData.tippani_generated"
                           class="text-white"
                           color="blue mr-2">
                      Print tippani
                    </v-btn>
                    <v-btn @click="exemptionDialog = true" class="text-white mr-2" color="blue"
                           v-if="(!trekkingData.voucher_number || trekkingData.total_cost !== 0) && !trekkingData.paid">
                      Exempt cost
                    </v-btn>
                    <v-btn @click="print('voucher')" class="text-white mr-2" color="blue"
                           v-if="trekkingData.voucher_generated && !trekkingData.paid">
                      Print Voucher
                    </v-btn>
                    <v-btn @click="checkPayment" class="text-white" color="blue mr-2"
                           v-if="trekkingData.voucher_generated  && !trekkingData.paid && $oauth.checkIfHasPermission('check-trekking-payment-status')">
                      Check payment status
                    </v-btn>
<!--                    <v-btn @click="checkPayment" class="text-white" color="blue mr-2"-->
<!--                           v-if="trekkingData.voucher_generated   && $oauth.checkIfHasPermission('check-trekking-payment-status')">-->
<!--                      Check payment status-->
<!--                    </v-btn>-->
                    <v-btn class="text-white" @click="openPayDialog" color="blue mr-2"
                           v-if="trekkingData.voucher_generated && !trekkingData.paid && $oauth.checkIfHasPermission('pay-manual-trekking')">
                      Pay manually
                    </v-btn>
                    <v-btn @click="generateVoucher" class="text-white" color="blue mr-2"
                           :loading="loading"
                           v-if="!trekkingData.voucher_generated && parseFloat(trekkingData.total_cost) > 0.00">
                      Generate voucher
                    </v-btn>
                    <v-btn
                        @click="print('permit')"
                        class="text-white"
                        color="blue lighten-1 mr-2"
                        v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved'">
                      Print Permit
                    </v-btn>
                    <v-btn
                        @click="printSticker"
                        class="text-white"
                        color="blue lighten-1 mr-2"
                        v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved' && trekkingData.print_trekking_sticker &&  $oauth.checkIfHasPermission(['print-trekking-sticker'])">
                      Print Sticker
                    </v-btn>
                    <v-btn
                        @click="attachDocument"
                        class="white--text"
                        color="blue lighten-1 mr-2"
                        v-if="showAttachDocuments"
                    >

                      Attach Document(s)
                    </v-btn>
                    <v-btn
                        @click="rejectModal=true "
                        class="text-white mr-2"
                        color="red lighten-1"
                        v-if="!trekkingData.approve_rejected && trekkingData.can_verify && !trekkingData.voucher_generated &&!trekkingData.paid">
                      Reject
                    </v-btn>
                    <v-btn
                        @click="approveModal=true "
                        class="text-white mr-2"
                        color="primary"
                        v-if="showApprove">
                      Approve
                    </v-btn>
                  </v-layout>
                </v-footer>
              </v-tab-item>
              <v-tab-item value="history">
                <v-card flat :loading="loading">
                  <v-expansion-panels
                      v-model="panel"
                      multiple
                      v-if="trekkingData.assigned_track && trekkingData.assigned_track.length"
                      class="mb-4"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="subtitle-2">Forwarded Tracks
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <trekking-assignment-history
                            :history="trekkingData.assigned_track"
                            :id="trekkingData.id"/>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <visa-history :history="trekkingData.tracks"
                                :show_load_more="false" :trekking="true" :editable="true"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout class="show-on-print" v-if="trekkingData.status === 'Approved'">
      <print-permit :schedule="trekkingData.schedule" :total_cost="trekkingData.total_cost"
                    :trekkers="trekkingData.trekkers"
                    :trekking-route="trekkingData.trekkingRoute" :trekkingAgency="trekkingData.trekkingAgency"
                    :trekkingData="trekkingData" :user="user"
                    style="display: none"
      />
    </v-layout>
    <v-layout class="show-on-print"
              v-if="trekkingData.status === 'Approved' && trekkingData.print_trekking_sticker &&  $oauth.checkIfHasPermission(['print-trekking-sticker'])">
      <trekking-request-sticker-print :schedule="trekkingData.schedule" :total_cost="trekkingData.total_cost"
                                      :trekkers="trekkingData.trekkers"
                                      :trekking-route="trekkingData.trekkingRoute"
                                      :trekkingAgency="trekkingData.trekkingAgency"
                                      :trekkingData="trekkingData" :user="user"
                                      style="display: none"
      />
    </v-layout>
    <approve-modal-ui :director="director"/>
    <reject-modal-ui/>
    <attach-file-dialog
        :url="'trekking-requests/attach-file/'+trekkingData.id"
        @attached="costExempted"
        v-model="attachFileDialog"
        :file-already-attached="fileAlreadyAttached"
    />
    <manual-payment-dialog v-model="manualDialog" @paid="pay"
                           :url="'trekking-requests/pay-manually/'+trekkingData.id"/>
    <cost-exemption-dialog
        v-model="exemptionDialog"
        :max-amount="trekkingData.total_cost"
        :url="'trekking-requests/exempt-cost/'+trekkingData.id"
        @exempted="costExempted"
        :type="'trekking'"
    />
    <trekking-forward-dialog v-model="showForwardToUserModal" :purpose="forwardPurpose"/>
    <trekking-tippani-verification-modal @purposeCompleted="proceedCompletedPurpose"/>

    <v-layout class="show-on-print" v-show="trekkingData.voucher_generated && trekkingData.status === 'Applied'">
      <trekking-voucher-print class="show-on-print"
                              :trekkingData="trekkingData" style="display: none"/>
    </v-layout>
    <!--        <v-layout class="show-on-print" v-if="printType === 'tippani'">-->
    <trekking-request-tippani-print-content class="show-on-print" style="display: none"/>
    <!--        </v-layout>-->

    <v-dialog
        class="hide-on-print"
        persistent
        v-model="editTrekkingPriceModal"
        width="400">

      <v-card class="hide-on-print">
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit Trekking Price</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form class="pt-2 mx-2" lazy-validation ref="manualRef">
            <v-layout class="mt-2" row wrap>
              <v-flex xs12>
                <v-text-field
                    outlined
                    label="Total price (USD)"
                    v-model="trekkingData.total_cost"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>

        </v-card-text>
        <v-divider style="margin-top:31px;"/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="editTrekkingPriceModal = false"
              class="white--text"
              color="red darken-3"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="saveEditedTrekkingPrice"
              class="white--text"
              color="blue darken-3"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TrekkingRequestApproveModal from "../../../components/trekkingRequest/TrekkingRequestApproveModal";
import TrekkingRequestRejectModal from "../../../components/trekkingRequest/TrekkingRequestRejectModal";
import Print from './TrekkingRequestPrint';
import TrekkingRequestStickerPrint from "../TrekkingRequestStickerPrint";
import ListItemDetail from "../../../components/ListItemDetail";
import PaymentDetail from "../../../components/PaymentDetail";
import HeaderText from "../../../components/HeaderText";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText"
import FileDisplay from "../../../components/FileDisplay";
import FileListItemDetail from "../../../components/FileListItemDetail";
import TrekkingVoucherPrint from "../../../components/trekkingRequest/TrekkingVoucherPrint";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import VisaHistory from "../../visa/visa-request/VisaHistory";
import AttachFileDialog from "../../../components/dialogs/AttachFileDialog";

import moment from "moment";

import {GET_TIPPANI_WITH_TYPE} from "../../../store/action-type";
import {
  SET_SELECTED_TIPPANI,
  SET_GENERATED_TIPPANI,
  SET_PRINT_CONTENT,
  SET_PRINT_CONTENT_ONLY
} from "../../../store/mutation-type";
import TrekkingRequestTippaniPrintContent
  from "../../../components/trekkingRequest/TrekkingRequestTippaniPrintContent"
import Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import Http from "axios";
import {API_URL, VERSION} from "@/config/config";
import TrekkingForwardDialog from "@/components/trekkingRequest/TrekkingForwardDialog.vue";
import TrekkingAssignmentHistory from "@/views/trekking/TrekkingAssignmentHistory.vue";
import TrekkingTippaniVerificationModal from "@/components/trekkingRequest/TrekkingTippaniVerificationModal.vue";
import VisaTippaniVerificationModal from "@/components/visa/VisaTippaniVerificationModal.vue";

export default {
  components: {
    VisaTippaniVerificationModal,
    TrekkingTippaniVerificationModal,
    TrekkingAssignmentHistory,
    TrekkingForwardDialog,
    Print,
    FileDisplay,
    "approve-modal-ui": TrekkingRequestApproveModal,
    "reject-modal-ui": TrekkingRequestRejectModal, FileListItemDetail,
    'print-permit': Print,
    ListItemDetail,
    HeaderText,
    ConfirmationHeaderText, PaymentDetail, TrekkingVoucherPrint,
    ManualPaymentDialog,
    CostExemptionDialog,
    TrekkingRequestTippaniPrintContent,
    VisaHistory,
    AttachFileDialog,
    TrekkingRequestStickerPrint,
  },

  data() {
    return {
      title: 'Trekking',
      tab: null,
      panel: [1, 0],
      valid: true,
      errors: [],
      mainLoading: false,
      director: false,
      printTippani: false,
      manualDialog: false,
      attachFileDialog: false,
      headers: [
        {
          text: 'number',
          value: 'document_number'
        }, {
          text: 'type',
          value: 'document_type'
        },
        {
          text: 'validity',
          value: 'validity'
        }
      ],
      showTippaniBeforePrint: false,
      showVoucher: false,
      exemptionDialog: false,
      tippaniDialog: false,
      step: 1,
      quill: null,
      hide: false,
      printType: null,
      editTrekkingPriceModal: false,
      showForwardToUserModal: false,
      forwardPurpose: null,
    };
  },
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData", "loading"]),
    approveModal: {
      get() {
        return this.$store.state.TrekkingSingle.approveModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setApproveModal", value);
      }
    },
    rejectModal: {
      get() {
        return this.$store.state.TrekkingSingle.rejectModal;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setRejectModal", value);
      }
    },
    user() {
      return this.$store.state.AuthUser.user;
    },
    tippanis() {
      return this.$store.state.Tippani.tippanis;
    },
    selectedTippani: {
      get() {
        return this.$store.state.Tippani.selectedTippani;
      },
      set(value) {
        this.$store.commit(SET_SELECTED_TIPPANI, value)
      }
    },
    latest_status() {
      if (this.trekkingData && this.trekkingData.tracks) {
        const latest_status = this.trekkingData.tracks[0];
        let deleted_tracks = this.trekkingData.tracks.filter((i) => i.deletable && (i.deleted_at > latest_status.created_at));

        if (deleted_tracks.length > 0) {
          deleted_tracks.sort((a, b) => Date.parse(b.deleted_at) - Date.parse(a.deleted_at));
          return deleted_tracks[0].status + " Removed";
        }
        return latest_status.status;
      } else {
        return;
      }
    },
    statusColor() {
      if (this.latest_status) {
        if (this.latest_status.toLowerCase().includes('approved')) {
          return 'success';
        } else if (this.latest_status === 'Applied for trekking permit' || this.latest_status === 'Trekking rejected') {
          return 'red';
        } else if (this.latest_status.toLowerCase().includes('removed')) {
          return 'error';
        }
        {
          return 'primary'
        }
      } else {
        return 'red';
      }
    },
    showAttachDocuments() {
      const {approve_rejected, paid, can_attach_file, payment_detail} = this.trekkingData;

      // if (parseInt(payment_detail.amount) === 0) {
      //   return !approve_rejected && can_attach_file;
      // }
      // return !approve_rejected && can_attach_file;
      return can_attach_file;

    },
    fileAlreadyAttached() {
      const {file_attached} = this.trekkingData;
      return file_attached;
    },
    showForward() {
      const {automation_enabled, status, assignment, isTippaniVerified} = this.trekkingData;
      if (automation_enabled) {
        return (
            isTippaniVerified &&
            (status !== 'Approved') &&
            (!assignment || assignment.assignee_id === this.user.id) &&
            this.$oauth.checkIfHasPermission(['forward-trekking-request'])
        )
      }
      return false;
    },
    showTippaniVerification() {
      const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.trekkingData;
      if (automation_enabled) {
        return (
            tippani_generated &&
            !isTippaniVerified &&
            (status !== 'Approved') &&
            (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 0)
        );
      }
      return false;
    },
    showTippaniApprove() {
      const {automation_enabled, status, assignment, isTippaniVerified, tippani_generated} = this.trekkingData;
      if (automation_enabled) {
        return (
            tippani_generated &&
            isTippaniVerified &&
            (status !== 'Approved') &&
            (assignment && assignment.assignee_id === this.user.id && assignment.purpose === 2)
        );
      }
      return false;
    },
    showApprove() {
      console.log('this.trekkingData',this.trekkingData)
      const {
        paid,
        status,
        total_cost,
        approve_rejected,
        can_approve,
        automation_enabled,
        isTippaniApproved
      } = this.trekkingData
      let showApprove = (
          !approve_rejected
          && can_approve
          && (paid || parseFloat(total_cost) === 0.00)
      )
      console.log('showApprove',showApprove)
      console.log('isTippaniApproved',isTippaniApproved)

      if (automation_enabled) {
        return showApprove && isTippaniApproved;
      }
      return showApprove;
    }
  }
  ,
  methods: {
    ...
        mapActions("TrekkingSingle", [
          "resetState",
          "getTrekkingRequestDetail",
          "generateTippaniPdf",
          "checkPaymentStatus",
          "generateVoucherNumber",
          "verifyTrekkingRequest",
          "saveTippani",
          "generateTrekkingStickerPrintedTrack"
        ]),
    editTrekkingPrice() {
      this.editTrekkingPriceModal = true;
    }
    ,
    saveEditedTrekkingPrice() {
      this.loading = true;
      Http.post(API_URL + VERSION + '/trekking-requests/update-price/' + this.trekkingData.id, {price: this.trekkingData.total_cost}).then((res) => {
        this.$store.dispatch('TrekkingSingle/getSingleTrekkingRequestDetail', this.trekkingData.id)
        this.$store.commit('Notification/showSuccess', 'Trekking price updated successfully');
        this.editTrekkingPriceModal = false;
        this.loading = false;
      }).catch((err) => {
        this.$store.commit('Notification/showError', 'Something went wrong');
        this.loading = false;
      })
    }
    ,
    print(type) {
      if (type === 'tippani') {
        const content = document.getElementById('tippani_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }
      if (type === 'initial_tippani') {
        const content = document.getElementById('tippani_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content);
        setTimeout(() => {
          window.print()
        }, 100);
      }

      if (type === 'voucher') {
        const content = document.getElementById('voucher_print_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }
      if (type === 'permit') {
        const content = document.getElementById('permit_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content)
      }
      if (type === 'sticker') {
        const content = document.getElementById('sticker_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT_ONLY, content)
        this.generateTrekkingStickerPrintedTrack()
            .then(() => {
              setTimeout(() => {
                window.print()
              }, 100);
              this.$store.commit("Notification/showSuccess", "Trekking sticker printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      }
    }
    ,
    printSticker() {
      var self = this;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
        this.generateTrekkingStickerPrintedTrack()
            .then(() => {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              //Set Printer type (Refer to the help, there many of them!)
              cpj.clientPrinter = 0;
              cpj.printerCommandsCodePage = -1;
              //Set printer commands...
              self.trekkingData.trekkers.forEach(item => {
                cpj.printerCommands = item.permit_prn_content;
                cpj.sendToClient();
              });
              this.$store.commit("Notification/showSuccess", "Trekking sticker printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }
    },
    singlePrintSticker(id) {
      var self = this;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
        this.generateTrekkingStickerPrintedTrack()
            .then(() => {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              //Set Printer type (Refer to the help, there many of them!)
              cpj.clientPrinter = 0;
              cpj.printerCommandsCodePage = -1;
              //Set printer commands...
              self.trekkingData.trekkers.find(item => {
                if (item.id == id) {
                  cpj.printerCommands = item.permit_prn_content;
                  cpj.sendToClient();
                }
              });
              this.$store.commit("Notification/showSuccess", "Trekking sticker printed track generated successfully");
            })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }
    },

    jspmWSStatus() {
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
        return true;
      else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        // alert(
        //     "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm"
        // );
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        // alert("JSPM has blocked this website!");
        return false;
      }
    },
    pay() {
      let id = this.$route.params.id;
      this.getTrekkingRequestDetail(id).finally(() => {
        this.mainLoading = false;
      });
    }
    ,
    openPayDialog() {
      this.manualDialog = true;
    }
    ,
    generateVoucher() {
      this.loading = true;
      this.generateVoucherNumber().then(() => {
        this.loading = false;
        this.$store.commit('Notification/showSuccess', 'Voucher has been generated')
      }).catch((err) => {
        this.loading = false;
        this.$store.commit('Notification/showError', err.response.data.message)
      })
    }
    ,
    checkPayment() {
      this.checkPaymentStatus().then(() => {
        this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      }).catch((err) => {
        this.$store.commit('Notification/showError', 'Not paid')
      });
    }
    ,
    printVoucher() {
      this.printTippani = false;
      setTimeout(() => {
        window.print();
      }, 100)
    }
    ,
    costExempted() {
      let id = this.$route.params.id;
      this.getTrekkingRequestDetail(id)
    }
    ,
    verifyTrekking() {
      this.loading = true;
      this.verifyTrekkingRequest().then(() => {
        this.loading = false;
        this.$store.commit('Notification/showSuccess', 'The Trekking Request has been verified');
        this.costExempted();
      }).catch(() => {
        this.loading = false;
        this.$store.commit('Notification/showError', 'Something went wrong')
      })
    }
    ,
    async generateTippani() {
      this.step = 1;

      await this.$store.dispatch(GET_TIPPANI_WITH_TYPE, this.title);
      this.tippaniDialog = true;
      setTimeout(() => {
        if (!this.quill)
          this.quill = new Quill('#editor', {
            theme: 'snow',
            modules: {
              toolbar: [
                [{header: [1, 2, false]}],
                ['bold', 'italic', 'underline'],
              ],
            },
          });
      }, 200);
    },
    async forwardToUser(type) {
      this.forwardPurpose = type ? type : 0;
      this.showForwardToUserModal = true;
    },
    fillTippani() {
      let tippani = this.tippanis.find(i => i.id === this.selectedTippani);
      tippani = tippani.text;
      let currentYear = moment().format('Y');
      tippani = tippani.replace('@current_year', currentYear);
      tippani = tippani.replace('@total_trekkers', this.trekkingData.trekkers.length);
      tippani = tippani.replace('@trekking_route_name', this.trekkingData.trekkingRoute.name);
      tippani = tippani.replace('@trekking_agency_name', this.trekkingData.trekkingAgency.name);
      tippani = tippani.replace('@starting_date', this.trekkingData.starting_date);
      tippani = tippani.replace('@trekking_route_name', this.trekkingData.trekkingRoute.name);
      tippani = tippani.replace('@trekking_days', this.trekkingData.no_of_days);
      tippani = tippani.replace('@current_year', currentYear);
      tippani = tippani.replace('@total_trekkers', this.trekkingData.trekkers.length);
      tippani = tippani.replace('@trekking_agency_name', this.trekkingData.trekkingAgency.name);
      tippani = tippani.replace('@starting_date', this.trekkingData.starting_date);
      tippani = tippani.replace('@trekking_days', this.trekkingData.no_of_days);
      tippani = tippani.replace('@application_date_en', this.trekkingData.created_at.substr(0, 10));
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.quill.root.innerHTML = tippani;
    }
    ,
    cancel() {
      if (this.step === 1) {
        this.tippaniDialog = false;

      } else {
        this.hide = false;
        this.step = 1;
      }
    }
    ,
    proceed() {
      const tippani = this.quill.root.innerHTML;
      this.$store.commit(SET_GENERATED_TIPPANI, tippani);
      this.hide = true;
      this.step = 2;
    }
    ,
    async save() {
      await this.$dialog.confirm({
        text: "Are you sure want to save tippani ?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              try {
                const r = await this.saveTippani({
                  content: this.quill.root.innerHTML
                })
                this.tippaniDialog = false;
                this.$store.commit('Notification/showSuccess', 'Tippani generated successfully')
                if (this.trekkingData.automation_enabled) {
                  this.showForwardToUserModal = true;
                }
              } catch (e) {
                this.tippaniDialog = false;

              }


            }
          }
        }
      });
    }
    ,
    attachDocument() {
      this.attachFileDialog = true;
    }
    ,
    getAge(dob) {
      return moment().diff(dob, 'years', false);
    },
    verifyTippaniGenerated() {
      this.$store.commit("TrekkingSingle/setTippaniVerificationModal", true);
      this.$store.commit("TrekkingSingle/setForwardPurpose", 'verify-tippani');
    },
    approveTippaniGenerated() {
      this.$store.commit("TrekkingSingle/setTippaniVerificationModal", true);
      this.$store.commit("TrekkingSingle/setForwardPurpose", 'approve-tippani');
    },
    proceedCompletedPurpose(data = null) {
      this.getTrekkingRequestDetail(this.trekkingData.id);
      if (this.trekkingData.automation_enabled) {
        if (data && data === 'verify-tippani') {
          this.forwardToUser(2)
        }
      }
    },

  }
  ,
  watch: {
    "$route.params.id":

        function () {
          if(this.route.name === 'ViewTrekkingRequest'){
            this.mainLoading = true;
            let id = this.$route.params.id;
            this.getTrekkingRequestDetail(id).finally(() => {
              this.mainLoading = false;
            });
          }
        }
  },
  mounted() {
    this.mainLoading = true;
    let id = this.$route.params.id;
    this.getTrekkingRequestDetail(id).finally(() => {
      this.mainLoading = false;
    });

    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    const self = this;
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (self.jspmWSStatus()) {
        //get client installed printers
        JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          // var options = "";
          // for (var i = 0; i < myPrinters.length; i++) {
          //   options += "<option>" + myPrinters[i] + "</option>";
          // }
          console.log(myPrinters);
          // $("#installedPrinterName").html(options);
          self.printers = myPrinters;
        });
      }
    };

  }
}
;
</script>

<style>
.hide {
  display: none;
}
</style>
